import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    agreement: {},
    isLoadingAgreement: false
  },
  getters: {
    getAgreement: (state) => state.agreement,
    getIsLoadingAgreement: (state) => state.isLoadingAgreement
  },
  mutations: {
    reset (state) {
      state.agreement = {}
    },
    setAgreement (state, payload) {
      state.agreement = payload
    },
    toggleLoadingAgreement (state) {
      state.isLoadingAgreement = !state.isLoadingAgreement
    }
  },
  actions: {
    async fetchAgreement ({ commit }, id) {
      commit('toggleLoadingAgreement')
      const response = await new ApiService(`${id}`).getResults()
      commit('setAgreement', response)
      commit('toggleLoadingAgreement')
    }
  }
}
